module.exports = __webpack_public_path__ + "static/media/fgn_my.b4735946.png";